module.exports = __webpack_public_path__ + "img/secure_2fa.92517b38.svg";